export default class WordCounter {
  constructor(node) {
    this.element = node;
    this.textAreaInput = this.element.querySelector(".js-textarea-input");
    this.currentWordCounter = this.element.querySelector(".js-word-counter-current");
    this.maxWordCounter = this.element.querySelector(".js-word-counter-max");
    this.maxWordCounter.innerHTML = this.textAreaInput.maxLength;

    this.currentValue = parseInt(this.currentWordCounter.innerHTML);
    this.maxValue = parseInt(this.maxWordCounter.innerHTML);

    this.initialize();

    this.boundFunction = this.currentWordCountValueChanged.bind(this);
    this.textAreaInput.addEventListener("input", this.boundFunction);
  }

  initialize() {
    this.updateWordCount();
    this.currentWordCountValueChanged();
  }

  updateWordCount() {
    this.currentValue = this.textAreaInput.value.length;
    this.element.classList.toggle("limit-reached", this.currentValue >= this.maxValue);
  }

  currentWordCountValueChanged() {
    this.updateWordCount();
    this.currentWordCounter.innerHTML = this.currentValue;
  }
}
